import React from 'react'
import { Message } from './types'
import TranscriptWithAudio from './transcript-with-audio'

interface CallSentence {
  id: number
  paragraph_id: number
  recording_id: number
  speaker_id: number
  text: string
  start: number
  end: number
}

interface CallParagraph {
  id: number
  start: number
  end: number
  speaker: {
    id: number
    friendly_name: string
    image_url: string | null
    user_contact_id: number | null
    user_id: number | null
  }
  sentences: CallSentence[]
}

interface SimpleCallModalProps {
  show: boolean
  onClose: () => void
  message: Message
}

const SimpleCallModal: React.FC<SimpleCallModalProps> = ({
  show,
  onClose,
  message,
}) => {
  // Extract data from message.call
  const paragraphs: CallParagraph[] =
    message.call?.recording_data?.paragraphs || []
  const hasTranscription = message.call?.recording_data?.transcribed || false
  const audioUrl = message.call?.recording_url
  const callDuration = message.call?.duration || 0
  const isVoicemail = message.call?.voicemail || false

  return (
    <TranscriptWithAudio
      show={show}
      onClose={onClose}
      message={message}
      title={isVoicemail ? 'Voicemail Transcript' : 'Call Transcript'}
      paragraphs={paragraphs}
      hasTranscription={hasTranscription}
      isVoicemail={isVoicemail}
      callDuration={callDuration}
      audioUrl={audioUrl || undefined}
      audioId={`simple-call-${message.id}`}
    />
  )
}

export default SimpleCallModal
